/* import __COLOCATED_TEMPLATE__ from './client-form-redesign.hbs'; */
import ContactInformationClientForm from './client-form';

export default class ContactInformationClientFormRedesign extends ContactInformationClientForm {}
